$(document).ready(function () {
  window.giftLoading = false;
});

window.giftItem = () => {
  if (window.giftLoading) {
    return;
  }

  window.giftLoading = true;

  const prd_id = $(".product_id").val();
  const prd_cart_limit = $(".price_limit").val();

  if (prd_id && prd_cart_limit) {
    $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
      const cartItems = result.items;
      const cart_subTotal = result.total_price;
      const hasAddonItemInCart = cartItems.filter((item) => item.id == prd_id);
      const isGift = hasAddonItemInCart.length > 0;

      if (cartItems.length === 0) {
        $(".hide_wrapper").hide();
      } else if (cartItems.length === 1 && !isGift) {
        $(".hide_wrapper").show();
      }

      if (!isGift) {
        $(".js__success_addon").hide();
      }

      if (cart_subTotal >= prd_cart_limit && !isGift) {
        addGiftToCart(prd_id);
      } else if (cart_subTotal < prd_cart_limit && isGift) {
        removeGiftFromCart(hasAddonItemInCart[0].key);
      } else {
        window.giftLoading = false;
      }
    });
  }
};

function addGiftToCart(prd_id) {
  $.ajax({
    type: "POST",
    url: window.Shopify.routes.root + "cart/add.js",
    data: {
      quantity: 1,
      id: prd_id,
      properties: { 'free_product': 'Free product' }
    },
    dataType: "json",
    success: function (data) {
      $(".js__success_addon").show();
      $(".hide_wrapper").hide();
      openCartDrawer();
    },
    error: function () {
      console.error("Error adding gift to cart");
    },
    complete: function () {
      window.giftLoading = false;
    }
  });
}

function removeGiftFromCart(cartKey) {
  const formData = {
    updates: {}
  };
  formData["updates"][cartKey] = 0;

  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(formData)
  })
    .then((response) => response.json())
    .then((result) => {
      openCartDrawer();
    })
    .catch((error) => {
      console.error("Error removing gift from cart", error);
    })
    .finally(() => {
      window.giftLoading = false;
    });
}

function openCartDrawer() {
  const cart = new theme.CartDrawer();
  cart.init();
  cart.open();
}

window.updateCartItem = (key, qty) => {
  const formData = {
    updates: {}
  };
  formData["updates"][key] = qty;

  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(formData)
  })
    .then((response) => response.json())
    .catch((error) => {
      console.error("Error updating cart item", error);
    })
    .finally(() => {
      window.giftLoading = false;
    });
};

